module.exports = __webpack_public_path__ + "img/Email1.4afdcbf4.png";